<script lang="ts">
  let { phase }: { phase: 'charge' | 'burst' } = $props()
</script>

<!-- The energy beam the motes stream into: it fills up from the center, then
charges — vibrating, widening, and brightening — before snapping to full
height and splitting open like a curtain at the reveal. Hard edges, no blur. -->
<div class="pillar-anchor" aria-hidden="true">
  {#if phase === 'charge'}
    <!-- The wrapper vibrates, the core fills/widens/brightens: two elements
    so the two animations don't fight over the same transform. -->
    <div class="seam">
      <div class="core"></div>
    </div>
  {:else}
    <div class="blade" style:--_direction={-1}></div>
    <div class="blade" style:--_direction={1}></div>
  {/if}
</div>

<style lang="postcss">
  .pillar-anchor {
    display: grid;
    position: absolute;
    place-items: center;
    inset: 0;
    pointer-events: none;
    > :global(*) {
      grid-area: 1 / 1;
    }
  }
  .core,
  .blade {
    border-inline: 2px solid var(--reveal-ring, var(--reveal-hue));
    background: color-mix(in oklab, var(--reveal-hue) 35%, white);
  }
  .seam {
    /* A fast, purely horizontal vibration once the charge begins. */
    animation: seam-shake 80ms linear 350ms infinite alternate;
    width: 0.5rem;
    height: min(34vmin, 14rem);
  }
  .core {
    /* Quick fill from the center, then a steady widen-and-brighten crescendo
       that peaks at 2350ms — right when the earliest reveal can fire. If the
       robot needs longer to load, the critical-state pulse keeps it alive. */
    animation:
      core-fill 350ms cubic-bezier(0.22, 1, 0.36, 1) forwards,
      core-charge 2000ms linear 350ms forwards,
      core-pulse 350ms ease-in-out 2350ms infinite alternate;
    width: 100%;
    height: 100%;
  }
  .blade {
    animation: blade-split 650ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    width: 0.5rem;
    height: min(84vmin, 34rem);
  }
  @keyframes seam-shake {
    from {
      transform: translateX(-1.5px);
    }
    to {
      transform: translateX(1.5px);
    }
  }
  @keyframes core-fill {
    from {
      transform: scaleY(0.15);
    }
    to {
      transform: scaleY(1);
    }
  }
  @keyframes core-charge {
    from {
      transform: scaleY(1) scaleX(1);
      filter: brightness(1);
    }
    to {
      transform: scaleY(1) scaleX(1.8);
      filter: brightness(1.8);
    }
  }
  @keyframes core-pulse {
    from {
      filter: brightness(1.8);
    }
    to {
      filter: brightness(1.45);
    }
  }
  @keyframes blade-split {
    0% {
      transform: translateX(0) scaleY(0.45);
      opacity: 1;
    }
    18% {
      transform: translateX(0) scaleY(1);
    }
    70% {
      opacity: 1;
    }
    100% {
      transform: translateX(calc(var(--_direction) * min(44vmin, 17.5rem)))
        scaleY(1);
      opacity: 0;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .seam,
    .core {
      animation: none;
    }
    .blade {
      animation: blade-fade 400ms ease-out forwards;
    }
    @keyframes blade-fade {
      to {
        opacity: 0;
      }
    }
  }
</style>
